import { DefaultButton } from '@fluentui/react';
import { DeleteRegular } from '@fluentui/react-icons';
import { useIntl } from 'react-intl';
import styles from './DeleteButton.module.scss';
import clsx from 'clsx';

interface DeleteButtonProps {
  itemCount: number;
  onClick: () => void;
  className?: string;
  totalCount?: number;
  showAllOption?: boolean;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  itemCount,
  onClick,
  className,
  totalCount,
  showAllOption = false,
}) => {
  const intl = useIntl();

  const getDeleteText = () => {
    if (showAllOption && itemCount === 0 && totalCount && totalCount > 0) {
      return intl.formatMessage({ id: 'common.deleteAll' }, { count: totalCount });
    }
    return intl.formatMessage({ id: 'common.deleteWithCount' }, { count: itemCount });
  };

  const isDisabled = !itemCount && (!showAllOption || !totalCount);

  return (
    <DefaultButton
      onClick={onClick}
      disabled={isDisabled}
      className={clsx(styles.deleteButton, (itemCount || (showAllOption && totalCount)) && styles.hasItems, className)}
    >
      <DeleteRegular className={styles.icon} />
      {getDeleteText()}
    </DefaultButton>
  );
};
